/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OAuthAppClientCredentials { 
    /**
     * Client Id for the related oauth app.
     */
    client_id?: string;
    /**
     * Secret key for the oauth app client credentials.
     */
    client_secret?: string;
    /**
     * Secret manager path where we would be storing client secret in Cloud.
     */
    client_sm_path?: string;
    /**
     * Timestamp when secret was last updated in Secrets Manager.
     */
    client_sm_update_timestamp?: Date;
}

